export const indexBooleanOptions = [
  { label: "Yes", value: "1" },
  { label: "No", value: "0" },
  { label: "All", value: "" },
];
